import Task from "../../../../model2/task/task"


// Union of every project the selected tasks live in - main project plus any
// linked ones for multi-project tasks. Membership in this set is what the
// "project users" bucket checks against.
export function getAllProjectIds(tasks: Task[]): ID[] {
    const ids : Set<ID> = new Set()
    _.each(tasks, (task: Task) => {
        _.each(task.projects, (projectItem: any) => ids.add(projectItem.projectId))
    })
    return Array.from(ids)
}


// Unique workspace-root project ids that the selected tasks belong to. Skips
// tasks whose default project has no workspace (root-level projects). An empty
// result means "no workspaces involved" - callers degenerate to project-only
// logic in that case.
export function getAllWorkspaceProjectIds(tasks: Task[]): ID[] {
    const ids : Set<ID> = new Set()
    _.each(tasks, (task: Task) => {
        const project = task.defaultProject
        if (!project) return
        const workspace = project.workspace
        if (workspace) ids.add(workspace.project.id)
    })
    return Array.from(ids)
}


// Intersection: users that are already task_users on EVERY selected task.
// These are excluded from the candidate buckets - nothing left to add.
export function getUsersOnAllTasks(tasks: Task[], taskUserIdsByTaskId: Map<ID, ID[]>): Set<ID> {
    if (!tasks.length) return new Set()

    const firstUsers : Set<ID> = new Set(taskUserIdsByTaskId.get(tasks[0].id) || [])

    _.each(tasks.slice(1), (task: Task) => {
        const taskUsers : Set<ID> = new Set(taskUserIdsByTaskId.get(task.id) || [])
        firstUsers.forEach((uid: ID) => {
            if (!taskUsers.has(uid)) firstUsers.delete(uid)
        })
    })

    return firstUsers
}
